export default __webpack_public_path__ + "static/media/mars-rotation.368407e9.gif";